import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import getAllCards from "../../endpoints/FlashCards/functions";
import PlayCards from "../../components/PlayContent/Cards/PlayCards";
import { Card, CardActions, CardContent, Button } from "@mui/material";
const PlayHome = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const filter = {
    category: searchParams.get("category") || "",
    deck: searchParams.get("deck") || "",
    shuffle: searchParams.get("shuffle") === "true",
    study: searchParams.get("study") === "true",
    search: searchParams.get("search") || "",
  };
  const [playingCards, setPlayingCards] = useState([]);
  const [index, setIndex] = useState(0);
  const [total, setTotal] = useState(0);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (!props.token) {
      return navigate("/flashcards");
    }

    const fetchCards = async () => {
      try {
        setLoading(true);
        let data = await getAllCards(props.token, filter);
        if (data.length === 0) {
          setShowAlert(true);
          return;
        }
        setPlayingCards(data);
        setTotal(data.length);
      } catch (error) {
        console.log("Error occured at PlayHome mount", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCards();
    // eslint-disable-next-line
  }, [location.search]);

  if (showAlert) {
    return (
      <div id="playing-mode-alert" className="page">
        <Card sx={{ boxShadow: "var(--box-shadow)" }}>
          <div className="header">
            <h1>No Cards Found</h1>
          </div>
          <CardContent>
            Looks like you do not have cards for the selection you made. Click
            below to return to the home page.
          </CardContent>
          <CardActions>
            <Button
              onClick={() => navigate(-1)}
              disableElevation
              color="black"
              variant="contained"
              className="py-1"
              sx={{ width: "8rem" }}
            >
              Go Back
            </Button>
          </CardActions>
        </Card>
      </div>
    );
  }
  if (!showAlert && filter) {
    return (
      <PlayCards
        total={total}
        loading={loading}
        playingCards={playingCards}
        index={index}
        setIndex={setIndex}
        token={props.token}
      />
    );
  }
};

export default PlayHome;
